import React, {Component} from "react"
import PropTypes from "prop-types"

import {Button} from "~/components"
import BlobDownload from "~/utils/BlobDownload"

export default class DownloadButton extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false
    }
  }

  componentDidMount() {
    const filename =
      this.props.filename || this.props.endpoint.replace(/\/|(_csv)/g, "")
    const options = {}
    if (this.props.mimeType) options.mimeType = this.props.mimeType
    if (this.props.v2) options.headers = {Accept: "application/vnd.shelf.v2"}

    this.downloader = new BlobDownload(this.props.endpoint, filename, options)
  }

  clickHandler = () => {
    if (this.state.loading) return

    if (this.downloader.isLoaded()) {
      this.downloader.getFile()
    } else {
      this.setState({loading: true})
      this.download()
    }
  }

  handleError = err => {
    if (this.props.automaticRetry && err.response.status === 404) {
      setTimeout(this.download, 3000)
    } else {
      this.setState({loading: false})
    }
  }

  download = () => {
    this.downloader
      .loadFile()
      .then(() => this.setState({loading: false}))
      .catch(err => this.handleError(err))
  }

  componentWillUmount() {
    this.downloader.freeResources()
  }

  render = () => (
    <Button
      secondary
      loading={this.state.loading}
      label={this.props.label}
      onClick={() => this.clickHandler()}
    />
  )
}

DownloadButton.propTypes = {
  endpoint: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  filename: PropTypes.string,
  mimeType: PropTypes.string,
  automaticRetry: PropTypes.bool,
  v2: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/decorators/DownloadButton.js